import React, { useState } from "react";
import { ThemMoiCapDuyet } from "./ThemMoiCapDuyet";

export const AddTaiKhoanDesktopBtn = (data) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  }

  return (
    <div className="iconbutton-new hidden-mobile-main show-table-main">
       <div className="row">
              <div className="col-sm-12 col-md-9">
                <button
                  type="button"
                  className="btn btn-border-new"
                  onClick={handleShow}
                >
                  <img
                    src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                    style={{ paddingBottom: "5px" }}
                  />{" "}
                  Thêm mới
                </button>
              </div>
            </div>
      {show && <ThemMoiCapDuyet data = {data} show={show} onHide={handleClose} />}
    </div>
  );
};
